import React from 'react';
import toast from 'react-hot-toast';
import CloseIcon from 'pencil/icons/Close';
import IconButton from 'pencil/IconButton';
import Button from 'pencil/Button';
import {
  isNotificationTruncated,
  truncateNotification,
  markNotificationAsRead,
} from 'domain/layout/utils';
import {
  getNotificationBody,
  getNotificationIcon,
  getNotificationStyle,
  getCloseNotificationButtonColor,
} from 'domain/layout/model';

const NotificationContent = (props) => {
  const {
    classes,
    row,
    expandedNotifications,
    closedNotifications,
    handleExpandNotification,
    setClosedNotifications,
    markNotificationAsClosed,
    setAllNotifications,
  } = props;

  return (
    <div>
      <div className={classes.toastIcon}>{getNotificationIcon(row)}</div>
      <div className={classes.notificationMessage}>
        {expandedNotifications.includes(row.id) ? (
          <p className={classes.notificationMessage}>{getNotificationBody(row)}</p>
        ) : (
          <div className={classes.notificationMessage}>
            {truncateNotification(getNotificationBody(row), 100)}
            {' '}
            {isNotificationTruncated(getNotificationBody(row), 100) && (
              <Button
                className={classes.showMoreBtn}
                size="small"
                onClick={() => handleExpandNotification(row.id)}
              >
                Show more
              </Button>
            )}
          </div>
        )}
        <IconButton
          aria-label="Close"
          className={classes.closeToast}
          onClick={() => {
            toast.dismiss(row.id);
            markNotificationAsClosed(row.id);
            setClosedNotifications([...closedNotifications, row.id]);
            markNotificationAsRead(row.id);
            setAllNotifications((prev) => prev.filter((notification) => notification.id !== row.id));
          }}
          style={getCloseNotificationButtonColor(row)}
        >
          <CloseIcon />
        </IconButton>
      </div>
    </div>
  );
};

export function renderAllNotifications(
  classes,
  expandedNotifications,
  allNotifications,
  setAllNotifications,
  closedNotifications,
  handleExpandNotification,
  setClosedNotifications,
  markNotificationAsClosed,
) {
  allNotifications.slice(0, 3).forEach((row) => {
    if (!closedNotifications.includes(row.id)) {
      toast(
        <div className={classes.tostBody} key={row.id}>
          <NotificationContent
            classes={classes}
            row={row}
            expandedNotifications={expandedNotifications}
            closedNotifications={closedNotifications}
            handleExpandNotification={handleExpandNotification}
            setClosedNotifications={setClosedNotifications}
            markNotificationAsClosed={markNotificationAsClosed}
            setAllNotifications={setAllNotifications}
          />
        </div>,
        {
          id: row.id,
          style: getNotificationStyle(),
          duration: 7000,
        },
      );
    }
  });
}

export function renderExpandedNotifications(
  classes,
  expandedNotifications,
  allNotifications,
  setAllNotifications,
  closedNotifications,
  handleExpandNotification,
  setClosedNotifications,
  markNotificationAsClosed,
) {
  expandedNotifications.slice(0, 3).forEach((expandedId) => {
    const row = allNotifications.find((notification) => notification.id === expandedId);
    if (row && !closedNotifications.includes(row.id)) {
      toast(
        <div className={classes.tostBody} key={row.id}>
          <NotificationContent
            classes={classes}
            row={row}
            expandedNotifications={expandedNotifications}
            closedNotifications={closedNotifications}
            handleExpandNotification={handleExpandNotification}
            setClosedNotifications={setClosedNotifications}
            markNotificationAsClosed={markNotificationAsClosed}
            setAllNotifications={setAllNotifications}
          />
        </div>,
        {
          id: row.id,
          style: getNotificationStyle(),
          duration: 7000,
        },
      );
    }
  });
}
